module.exports = __webpack_public_path__ + "static/media/mobileCharlieAddIcon.a2c2a3f7.svg";